import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    CheckCircleIcon,
    RocketLaunchIcon,
    ChatBubbleLeftRightIcon,
    ClockIcon,
    ShieldCheckIcon
} from '@heroicons/react/24/outline';

const Success = () => {
    const navigate = useNavigate();

    // Redireciona para o feed após 10 segundos se o usuário ficar parado
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/dashboard/feed');
        }, 10000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="min-h-[80vh] flex flex-col items-center justify-center p-6 animate-fade-in font-sans">
            {/* Celebration Background Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-emerald-500/10 blur-[150px] rounded-full -z-10 animate-pulse"></div>

            <div className="w-full max-w-2xl bg-white/[0.03] backdrop-blur-3xl border border-emerald-500/20 rounded-[3.5rem] p-12 text-center shadow-3xl relative overflow-hidden">

                {/* Animated Check Icon */}
                <div className="flex justify-center mb-8">
                    <div className="relative">
                        <div className="absolute inset-0 bg-emerald-500 blur-2xl opacity-40 animate-pulse"></div>
                        <div className="w-24 h-24 bg-emerald-500 rounded-full flex items-center justify-center relative z-10 shadow-2xl">
                            <CheckCircleIcon className="w-16 h-16 text-black stroke-[2]" />
                        </div>
                    </div>
                </div>

                <h1 className="text-4xl md:text-5xl font-black italic text-white uppercase tracking-tighter mb-4">
                    PAGAMENTO <span className="text-emerald-500">RECEBIDO!</span>
                </h1>

                <p className="text-xl font-bold text-gray-300 mb-8 uppercase tracking-widest italic">
                    Prepare-se para a sua estreia
                </p>

                <div className="bg-black/40 border border-white/5 rounded-3xl p-8 mb-10 space-y-6 text-left">
                    <div className="flex items-start gap-4">
                        <ClockIcon className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-1" />
                        <div>
                            <p className="text-white font-bold uppercase text-sm tracking-wide">Liberação em instantes</p>
                            <p className="text-gray-500 text-xs mt-1">Nossa equipe está processando seu pagamento. Seu acesso VIP será ativado automaticamente em até 15 minutos.</p>
                        </div>
                    </div>

                    <div className="flex items-start gap-4 border-t border-white/5 pt-6">
                        <RocketLaunchIcon className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-1" />
                        <div>
                            <p className="text-white font-bold uppercase text-sm tracking-wide">O que acontece agora?</p>
                            <p className="text-gray-500 text-xs mt-1">Você será redirecionado para o Feed de Aulas. Caso o conteúdo ainda apareça bloqueado, basta atualizar a página em alguns instantes.</p>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={() => navigate('/dashboard/feed')}
                        className="px-10 py-5 bg-emerald-600 hover:bg-emerald-500 text-white font-black rounded-2xl transition-all shadow-xl shadow-emerald-600/20 uppercase tracking-tighter flex items-center justify-center gap-3 active:scale-95"
                    >
                        Ir para o Feed de Aulas
                    </button>

                    <button
                        onClick={() => window.open(process.env.REACT_APP_WHATSAPP_LINK || 'https://wa.me/0000000000000', '_blank')}
                        className="px-10 py-5 bg-white/5 hover:bg-white/10 text-white font-black border border-white/10 rounded-2xl transition-all uppercase tracking-tighter flex items-center justify-center gap-3"
                    >
                        <ChatBubbleLeftRightIcon className="w-6 h-6" />
                        Suporte WhatsApp
                    </button>
                </div>

                <div className="mt-12 flex items-center justify-center gap-6 opacity-40">
                    <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-white">
                        <ShieldCheckIcon className="w-4 h-4 text-emerald-500" />
                        Acesso 100% Protegido
                    </div>
                    <div className="w-1 h-1 bg-gray-600 rounded-full"></div>
                    <div className="text-[10px] font-black uppercase tracking-[0.2em] text-white">
                        Vaga Confirmada
                    </div>
                </div>

            </div>

            <p className="mt-8 text-gray-600 text-[10px] font-bold uppercase tracking-[0.3em] animate-pulse">
                Redirecionando automaticamente em 10 segundos...
            </p>
        </div>
    );
};

export default Success;
